import React, { useState, useEffect } from 'react';
import { Row, Col, Tabs, Tab } from "react-bootstrap"
import { Page, SearchBar } from 'components';
import { Results, QrResults } from './components';
import Header from '../../components/Header/Header';
import Reload from '../../components/Reload/Reload';
import ApiDataEngine from 'services/ApiDataEngine';
import { useAppTheme } from '../../contexts/ThemeContext';

const Nir = (props) => {

  const user = JSON.parse(localStorage.getItem('userData'));
  if (user?.permission?.nir?.read !== true) {
    window.location.replace('/home');
  }

  const [equipments, setEquipments] = useState([]);
  const [equipmentsToShow, setEquipmentsToshow] = useState([]);
  const [searchData, setSearchData] = useState('');
  const [searchQr, setSearchQr] = useState('');
  const [qrResults, setQrResults] = useState([]);
  const [activeTab, setActiveTab] = useState('equipments');
  const [loading, setLoading] = useState(true);

  const STORAGE_KEY = 'filters:nir';

  const currentTheme = useAppTheme();

  // Load persisted filters on mount
  useEffect(() => {
    const persisted = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (persisted) {
      if (typeof persisted.searchData === 'string') setSearchData(persisted.searchData);
    }
  }, []);

  // Persist filters when they change
  useEffect(() => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ searchData })
    );
  }, [searchData]);

  const getEquipments = async () => {
    setLoading(true);
    try {
      const { data } = await ApiDataEngine.get('/measurements-nir/v1/details');
      const equipmentsData = Array.isArray(data) ? data : [];
      const sortedData = equipmentsData.sort((a, b) => {
        const serialA = a.serialnumber || '';
        const serialB = b.serialnumber || '';
        return serialA.localeCompare(serialB);
      });
      setEquipments(sortedData);
      setEquipmentsToshow(sortedData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEquipments();
  }, [])

  const handleSearch = React.useCallback(() => {
    if (searchData === '') {
      setEquipmentsToshow(equipments);
    } else {
      let equipmentsSearch = [...equipments];

      if (searchData !== '') {
        equipmentsSearch = equipmentsSearch.filter(item =>
          item?.serialnumber?.toLowerCase().includes(searchData.toLowerCase()) ||
          item?.nameEquipament?.toLowerCase().includes(searchData.toLowerCase())
        );
      }

      setEquipmentsToshow(equipmentsSearch);
    }
  }, [equipments, searchData]);

  const handleSearchData = (e) => {
    setSearchData(e.target.value);
  };

  const handleSearchQr = React.useCallback(async () => {
    if (searchQr.length !== 8 && searchQr.length !== 0) {
      return;
    }
    setLoading(true);
    try {
      const url = searchQr.length === 8
        ? `/api/link/packages?qrcode=${searchQr}`
        : `/api/link/packages`;

      const { data } = await ApiDataEngine.get(url);

      const normalizePackages = (payload) => {
        if (!payload) return [];
        if (Array.isArray(payload)) return payload;

        // Novo formato: { package: {...}, items: [...], ...pagination }
        if (payload.package && typeof payload.package === 'object') return [payload.package];

        if (Array.isArray(payload.items)) {
          return payload.items
            .map((i) => (i && typeof i === 'object' ? (i.package || i) : null))
            .filter(Boolean);
        }

        // Fallback: objeto único
        if (typeof payload === 'object') return [payload];
        return [];
      };

      const results = normalizePackages(data);
      setQrResults(results);
    } catch (error) {
      console.log('Erro ao buscar QR:', error);
      setQrResults([]);
    } finally {
      setLoading(false);
    }
  }, [searchQr]);

  // Auto-apply filters for equipments
  useEffect(() => {
    handleSearch();
  }, [equipments, searchData, handleSearch]);

  // Auto-trigger QR search exactly when 8 characters are typed or search is empty
  useEffect(() => {
    if (activeTab === 'qr') {
      if (searchQr.length === 8 || searchQr.length === 0) {
        handleSearchQr();
      }
    }
  }, [searchQr, activeTab, handleSearchQr]);

  return (
    <Page className="p-3" title="Nir">
      <Header page={'Nir'} />

      {loading && <Reload />}

      <Tabs
        activeKey={activeTab}
        onSelect={(k) => setActiveTab(k)}
        className="mb-3"
        variant={currentTheme === 'dark' ? 'pills' : 'tabs'}
      >
        <Tab eventKey="equipments" title="Equipamentos" />
        <Tab eventKey="qr" title="Qrcode" />
      </Tabs>

      {activeTab === 'equipments' ? (
        <>
          <Row className="align-items-center g-2">
            <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <SearchBar
                onSearch={handleSearch}
                onSearchData={handleSearchData}
                searchData={searchData}
              />
            </Col>
            <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center" />
          </Row>

          {equipmentsToShow && (
            <div className="mt-3">
              <Results
                user={user}
                data={equipmentsToShow}
                currentTheme={currentTheme}
                downloadsDisabled
                disableDetailsClick
              />
            </div>
          )}
        </>
      ) : (
        <>
          <Row className="align-items-center g-2">
            <Col xs={8} sm={6} md={6} lg={6} xl={6} xxl={6}>
              <SearchBar
                onSearch={() => { }}
                onSearchData={(e) => setSearchQr(e.target.value.toUpperCase())}
                searchData={searchQr}
                placeholder="Buscar por Qrcode... (Ex: NIR00198)"
              />
            </Col>
            <Col xs={4} sm={6} md={6} lg={6} xl={6} xxl={6} className="text-md-end text-center" />
          </Row>

          <div className="mt-3">
            <QrResults
              user={user}
              data={qrResults}
              currentTheme={currentTheme}
              loading={loading}
              downloadsDisabled
              disableDetailsClick
            />
          </div>

        </>
      )}
    </Page >
  );
};

export default Nir;
